import { addItemToTree, removeItemFromTree } from './tree';
export var moveItemOnTree = function moveItemOnTree(tree, from, to) {
  var _removeItemFromTree = removeItemFromTree(tree, from),
    treeWithoutSource = _removeItemFromTree.tree,
    itemRemoved = _removeItemFromTree.itemRemoved;
  return addItemToTree(treeWithoutSource, to, itemRemoved);
};